import { render } from "./parityDemo.vue?vue&type=template&id=247927b2&scoped=true"
import script from "./parityDemo.vue?vue&type=script&lang=js"
export * from "./parityDemo.vue?vue&type=script&lang=js"

import "../assets/css/game_parity.css?vue&type=style&index=0&id=247927b2&scoped=true&lang=css"
import "./parityDemo.vue?vue&type=style&index=1&id=247927b2&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-247927b2"]])

export default __exports__